import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '/public/homeview.css';
import axios from 'axios';
import qs from 'qs';


Vue.prototype.qs = qs;
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.axios = axios;

new Vue({
  router,
  store,
  render: h => h(App),
  mounted(){
  }
}).$mount('#app')
